import { z } from 'zod';

/**
 * Schema de validación para variables de entorno
 * Valida que todas las variables requeridas estén presentes
 */
const envSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1, 'Firebase API Key es requerida'),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1, 'Firebase Auth Domain es requerido'),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1, 'Firebase Project ID es requerido'),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1, 'Firebase Storage Bucket es requerido'),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1, 'Firebase Messaging Sender ID es requerido'),
  VITE_FIREBASE_APP_ID: z.string().min(1, 'Firebase App ID es requerido'),
  VITE_FIREBASE_MEASUREMENT_ID: z.string().optional(),
  VITE_API_BASE_URL: z.string().url('API Base URL debe ser una URL válida'),
});

/**
 * Valida y exporta las variables de entorno
 * Lanza error si faltan variables requeridas
 */
export const env = envSchema.parse({
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
  VITE_FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
});

